import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsers = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 20,
	height: 20,
	strokeWidth: 1.5,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 21v-2a4 4 0 0 0 -3 -3.85" })
	]
});
const ForwardRef = forwardRef(SvgUsers);
export default ForwardRef;
